import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { Box, IconButton } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { ExportButton } from "../../../../export/attendance-reports";
import ColumnSelector from "../../../design/column-selector";
import Searchbar from "../../../design/search-bar";

// Define the props for our new header component
interface TableHeaderProps {
	search?: string;
	setSearch?: (search: string) => void;
	columnSelector?: any[];
	handleSelectColumns?: (checked: boolean, field: string) => void;
	exportData?: any[];
	open?: boolean;
	setFilterOpen?: (open: boolean) => void;
}

const TableHeader = ({
	search,
	setSearch,
	columnSelector,
	handleSelectColumns,
	exportData,
	open,
	setFilterOpen,
}: TableHeaderProps) => {
	const { t } = useTranslation();
	return (
		<Box
			display='flex'
			alignItems='center'
			justifyContent='space-between'
			py={1.2}
			px={3}
		>
			<Box display='flex' alignItems={"center"}>
				<ColumnSelector
					columns={columnSelector}
					handleSelectColumns={handleSelectColumns}
					disabledColumns={["workerId"]}
				/>
				<Searchbar
					placeholder={t("time-off-balances_search-placeholder")}
					setSearch={setSearch}
					value={search}
					variant={"filled"}
					width={"60ch"}
				/>
			</Box>
			<Box>
				<ExportButton data={exportData ?? []} />
			</Box>
		</Box>
	);
};

export default TableHeader;